import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { WorkspaceLayout } from "../WorkspaceLayout";
import { WorkspaceProps } from "../WorkspaceProps";

export default function HomePage(props: NSARouterMakerResult & WorkspaceProps)
{
	return (
		<WorkspaceLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</WorkspaceLayout>
	);
}